<template>
  <div>
    <v-row>
      <v-col cols="8" lg="6" offset-lg="1">
        <h4>1. 一括発注用フォーマット（CSV）をダウンロードして下さい。</h4>
        <div class="mt-3 ml-6">
          <v-btn
            tile
            depressed
            color="grey lighten-3"
            @click="downloadTemplate()"
          >
            発注登録フォーマットを取得
            <v-icon right dark> mdi-download </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" lg="6" offset-lg="1">
        <h4>
          2 ダウンロードしたフォーマットに、発注するデータを入力して下さい。
        </h4>
        <v-card outlined color="grey lighten-3" class="mt-3 ml-6">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                ・フォーマットの使い方については
                <a
                  href="https://support.b-cms.jp/32"
                  rel="noopener noreferrer"
                  target="_blank"
                  >ヘルプページ
                </a>
                をご確認下さい
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" lg="6" offset-lg="1">
        <h4>3. 入力したフォーマットをアップロードして下さい。</h4>
        <div class="mt-3 ml-6">
          <v-card outlined color="grey lighten-3" class="mb-5">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  アップロードの前に以下をご確認下さい。
                </v-list-item-title>
                <v-list-item-title>
                  ・必ずファイルの拡張子が「.csv」となっていること
                </v-list-item-title>
                <v-list-item-title>
                  ・記入漏れ、誤記入がないこと
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <template v-if="status == 'success'">
            <v-alert outlined type="success">
              発注の登録が正常に完了しました。
            </v-alert>
          </template>
          <template v-else-if="status == 'error'">
            <ErrorsAlert :errors="errors" />
          </template>
          <v-card outlined>
            <template v-if="status == 'registering'">
              <v-progress-circular
                :size="70"
                :width="7"
                color="green"
                indeterminate
                style="display: block; margin: 40px auto"
              ></v-progress-circular>
              <p class="mb-5" style="text-align: center">
                発注を登録しています。完了するまでお待ちください。
              </p>
            </template>
            <template v-else>
              <v-card-text>
                <v-form ref="form">
                  <v-row>
                    <v-col cols="8" lg="6">
                      <v-file-input
                        v-model="orderRegistration.file"
                        autofocus
                        accept=".csv"
                        required
                        :rules="[presenceValidation]"
                        label="発注CSVファイル"
                      />
                      <v-textarea
                        v-model="orderRegistration.memo"
                        class="body-2"
                        auto-grow
                        label="発注メモ"
                      />
                    </v-col>
                    <v-col>
                      <v-btn color="primary" @click="registerOrders">
                        登録する
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </template>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import blobDownloader from '@/mixins/blob_downloader'
import axios from 'axios'
import ErrorsAlert from '@/components/commons/formParts/ErrorsAlert'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    ErrorsAlert
  },
  props: {
    originOrderRegistration: {
      type: Object,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  mixins: [blobDownloader, formValidationUtils],
  computed: {
    orderRegistration: {
      get () {
        return this.originOrderRegistration
      },
      set (value) {
        this.$emit('update-order-registration', value)
      }
    }
  },
  methods: {
    registerOrders () {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.$emit('register-orders', this.originOrderRegistration)
      this.clearFile()
    },
    downloadTemplate () {
      axios
        .get(`/api/order_registrations_csv`, {
          responseType: 'blob',
          params: { file_type: 'ja' }
        })
        .then(
          (response) => {
            this.downloadBlob(response)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    clearFile () {
      this.orderRegistration.file = null
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
